import { createFileRoute, Link, Navigate } from '@tanstack/react-router'
import { SignIn, useAuth } from '../lib/auth'

export const Route = createFileRoute('/login')({
  component: LoginPage,
})

function LoginPage() {
  const { isLoaded, isSignedIn } = useAuth()

  if (isLoaded && isSignedIn) {
    return <Navigate to="/app" />
  }

  return (
    <div className="min-h-screen bg-snow flex flex-col">
      <header className="p-4">
        <Link to="/" className="text-2xl font-display font-semibold text-charcoal">
          MiseBook
        </Link>
      </header>

      <main className="flex-1 flex items-center justify-center p-4">
        <SignIn />
      </main>
    </div>
  )
}
